import React from "react";
import { FaSearch } from "react-icons/fa";
import { normalizeDateInputValue } from "../../../components/forms/DateInput";

export const JumpToPageIcon = ({ page, fn }) => (
  <FaSearch
    onClick={() => {
      fn(page);
    }}
    key="create"
    style={{ cursor: "pointer" }}
  ></FaSearch>
);

function compareQc(values, key) {
  let original = values[key];
  let qc = values[`${key}_qc`];
  if (key === "face_amount") {
    original = original.split(".")[0].replaceAll("$", "").replaceAll(",", "");
    qc = qc.split(".")[0].replaceAll("$", "").replaceAll(",", "");
  } else if (key === "policy_date") {
    original = normalizeDateInputValue(original);
    qc = normalizeDateInputValue(qc);
    if (original instanceof Date && qc instanceof Date) {
      return original.getTime() === qc.getTime();
    } else {
      return false;
    }
  }
  return original === qc;
}

export function getQcStyle(values, key) {
  return compareQc(values, key) ? { color: "green" } : { color: "red" };
}

export function getQcClassColor(values, key) {
  return compareQc(values, key) ? "text-success" : "text-danger";
}

export function getQcTextColor(values, key) {
  return compareQc(values, key) ? "green" : "red";
}
